import { Icon, IconTypes } from '@eika/icon';
import './step.scss';
import { useStepProgressBarContext } from '../context';

export interface StepProps {
    iconType: IconTypes;
    completed?: boolean;
    children: string; // Label
}

export const Step = ({ iconType, completed = false, children }: StepProps) => {
    const { index, isComplete, activeStep } = useStepProgressBarContext();

    const isActiveStep = activeStep === index + 1;
    const isSecondStep = index === 1;

    const getStepIcon = () => {
        if (completed) {
            return IconTypes.CHECKMARK_TIL_SIRKEL_24;
        }

        if (isActiveStep && isSecondStep) {
            return IconTypes.TIMEGLASS_24;
        }

        return iconType;
    };

    if (isComplete) {
        return (
            <>
                <div id={children}>
                    <span className="step-progress-bar__step__icon--complete-process">
                        <Icon type={IconTypes.CHECKMARK_TIL_SIRKEL_24} />
                    </span>
                </div>
                <span className="step-progress-bar__step__label step-progress-bar__step__label--complete-process">
                    {children}
                </span>
            </>
        );
    }

    return (
        <>
            <div id={children}>
                <span
                    className={`step-progress-bar__step__icon ${completed ? 'step-progress-bar__step__icon--completed' : ''} ${isActiveStep ? 'step-progress-bar__step__icon--active' : ''}`}
                >
                    <Icon type={getStepIcon()} />
                </span>
            </div>

            <span
                className={`step-progress-bar__step__label ${isActiveStep ? 'step-progress-bar__step__label--active' : 'step-progress-bar__step__label--inactive'}`}
            >
                {children}
            </span>
        </>
    );
};
